<template>
  <div>
    <div class="card shadow-sm border-0 p-4 mb-4">
      <!-- Header Title -->
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 class="fw-bold mb-0 text-primary">
          <i class="bi bi-file-earmark-bar-graph me-2"></i>
          Trial Balance Report
        </h5>
      </div>

      <!-- Date Filters -->
      <div class="row g-3 align-items-center">
        <div class="col-md-6">
          <label class="form-label fw-semibold small text-secondary mb-1">
            <i class="bi bi-calendar3 me-1"></i>{{ $t('start_date') }}
          </label>
          <input
            type="date"
            class="form-control shadow-sm rounded-pill"
            v-model="filters.start_date"
          />
          <div v-if="errors.start_date" class="text-danger small mt-1">
            <i class="bi bi-exclamation-circle"></i> {{ errors.start_date }}
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label fw-semibold small text-secondary mb-1">
            <i class="bi bi-calendar3 me-1"></i>{{ $t('end_date') }}
          </label>
          <input
            type="date"
            class="form-control shadow-sm rounded-pill"
            v-model="filters.end_date"
          />
          <div v-if="errors.end_date" class="text-danger small mt-1">
            <i class="bi bi-exclamation-circle"></i> {{ errors.end_date }}
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="text-muted my-4" />

      <!-- Buttons -->
      <div class="d-flex justify-content-start gap-3 flex-wrap">
        <button @click="submitReport" class="btn btn-outline-primary rounded-pill px-4">
          <i class="bi bi-arrow-repeat me-2"></i>  Search
        </button>  
      </div>
    </div>

    <div class="card shadow-sm border-0 p-4 mb-4" v-if="trials.length > 0">
      <!-- Header Title -->
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 class="fw-bold mb-0 text-primary">
          <i class="bi bi-file-earmark-bar-graph me-2"></i>
          Trial Balance Report
        </h5>
      </div>


      <div class="table-responsive">
        <table class="table table-striped caption-top text-uppercase">
          <caption class="text-center">
          	<strong class="text-dark">Form: {{ filters.start_date ? dateFormat(filters.start_date) : '' }} - To: {{ filters.end_date ? dateFormat(filters.end_date) : '' }}</strong>
          </caption>
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>
              <th class="text-end">{{ $t("debit") }}</th>
              <th class="text-end">{{ $t("credit") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="trial in trials">
              <td>{{ getHeadName(trial.account_id) }}[{{ trial.account_id }}]</td>
              <td class="text-end">{{trial.debit}}</td>
              <td class="text-end">{{trial.credit}}</td>
            </tr>
          </tbody>
          <tfoot>
          	<tr>
              <th class="text-end">Total</th>
              <th class="text-end">{{total.debit}}</th>
              <th class="text-end">{{total.credit}}</th> 
            </tr>
          </tfoot>
        </table>

      </div>
    </div>
  </div>
</template>


<script>
import apiUrls from "@/urls";
import { useToast } from 'vue-toastification';
import feather from "../../../../../public/assets/js/feather.min";
import debounce from 'lodash.debounce'
import dayjs from 'dayjs'

export default {
  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      filters: {
        start_date: "",
        end_date: "",
      },
      errors: {},
      trials:[],
      heads:[],
      total:{
      	debit:0,
      	credit:0,
      }
    };
  },
  created() {
  },
  mounted(){
  	this.geAccountsHead()
  },
  methods: {
    dateFormat(date){
      if(!date) return;
      return dayjs(date).format('DD-MM-YYYY')
    },

    getHeadName(account_id) {
      
        const head = this.heads.find(item => item.account_id == account_id)
        return head ? head.node : ''
    },
  	async geAccountsHead(){
  		const response = await this.$axios.get(apiUrls.chart_of_accounts.get, {
            params: {status:'Child' }
          })
  		this.heads = response.data
  	},
	async submitReport() {
	    try {

	      const response = await this.$axios.get(apiUrls.report_trial_balance.get, {
	          params: this.filters
	        });
	      console.log(response)
	      this.trials = response.data.data

	      this.total.debit = 0
	      this.total.credit = 0
	      
	      this.trials = this.trials.map(item => {
	      	let t_debit = 0;
  		    let t_credit = 0;

  		    const itemDebit = parseFloat(item.total_debit);
  		    const itemCredit = parseFloat(item.total_credit);

  		    if(itemDebit >= itemCredit){

  		        t_debit = itemDebit - itemCredit;
  		        this.total.debit += t_debit;

  		    }else{

  		        t_credit = itemCredit - itemDebit;
  		        this.total.credit += t_credit;
  		    }

  		    return {
  		        ...item,
  		        debit: t_debit,
  		        credit: t_credit,
  		    }
	      })
	      console.log(this.trials)

	    } catch (error) {
	      console.log(error)
	    }
	},

    
  }
}

</script>

<style scoped>
caption{
  font-size:18px !important;
}
</style>